// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q52z","colMin":"styles_colMin__2XonW"};